"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAll = getAll;
exports.getById = getById;
exports.getDefault = getDefault;
exports.update = update;
exports.insert = insert;
exports.deleteById = deleteById;
exports.deleteByLibelle = deleteByLibelle;
exports.bulkDelete = bulkDelete;
exports.getMaxSort = getMaxSort;

var _request = _interopRequireDefault(require("@/helpers/request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAll() {
  return (0, _request.default)({
    url: '/libelle_facture',
    method: 'get'
  });
}

function getById(id) {
  return (0, _request.default)({
    url: '/libelle_facture/' + id,
    method: 'get'
  });
}

function getDefault() {
  return (0, _request.default)({
    url: '/libelle_facture/default',
    method: 'get'
  });
}

function update(id, data) {
  return (0, _request.default)({
    url: '/libelle_facture/' + id,
    method: 'put',
    data: data
  });
}

function insert(data) {
  return (0, _request.default)({
    url: '/libelle_facture',
    method: 'post',
    data: data
  });
}

function deleteById(id) {
  return (0, _request.default)({
    url: '/libelle_facture/' + id,
    method: 'delete'
  });
}

function deleteByLibelle(libelle) {
  return (0, _request.default)({
    url: '/libelle_facture/' + libelle,
    method: 'delete'
  });
}

function bulkDelete(ids) {
  return (0, _request.default)({
    url: '/libelle_facture/' + ids,
    method: 'delete'
  });
}

function getMaxSort() {
  return (0, _request.default)({
    url: '/libelle_facture/max-sort',
    method: 'get'
  });
}